export const routeName = 'LoadCalendarChangelogPage'

export const route = {
  path: '/load-calendar/changelog',
  name: routeName,
  component: () => import('./ChangelogPage.vue')
}
